export interface SettingsItemWithUserProps {
  user: Maybe<User>;
}

export enum ThemeModeNames {
  'system' = 'system',
  'dark' = 'dark',
  'light' = 'light',
}
